export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxIiBoZWlnaHQ9IjExNyIgdmlld0JveD0iMCAwIDEwMSAxMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjgzNTQ0OSAwLjUzNDE4TDEwMC44MzUgNTguMjY5NUwwLjgzNTU4MSAxMTYuMDA0TDAuODM1NDQ5IDAuNTM0MThaIiBmaWxsPSIjMDBGRkEzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./images/play.svg
// module id = 232
// module chunks = 0